<template>
  <div class="shopInformation">
    <Tabs :value="name1" @on-click="clickTab" :animated="false">
      <TabPane label="基础信息" name="0" class="fontsize" v-if="WSS30011">
        <div class="main">
          <div class="main-t">
            <p>
              2022-01-01至2022-12-31内店铺名称一共可以修改3次，您当前还可以修改{{
                this.formLeft.changeNameNum
              }}次，请谨慎填写
            </p>
            <p>
              2022-01-01至2022-12-31内经营地址一共可以修改3次，您当前还可以修改{{
                this.formLeft.changeAddrNum
              }}次，请谨慎填写
            </p>
          </div>
          <Form
            :model="formLeft"
            label-position="left"
            :label-width="120"
            ref="formInline"
            :rules="ruleInline"
          >
            <FormItem label="店铺名称：" prop="tenantShortName">
              <Input
                v-model="formLeft.tenantShortName"
                style="width: 92%"
                :disabled="disabledName"
              ></Input>
              <!-- <span class="iconfont icon-bianji"></span> -->
            </FormItem>
            <FormItem label="经营地址：" prop="cityId">
              <Select
                :disabled="disabledAddr"
                v-model="formLeft.provinceId"
                placeholder="请选择省份"
                style="width: 30%"
                @on-change="changeProvince"
              >
                <Option
                  v-for="item in provinceArr"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
              <Select
                :disabled="disabledAddr"
                v-model="formLeft.cityId"
                placeholder="请选择城市"
                style="width: 30%; margin: 0 1% 0 1%"
                @on-change="changeCity"
              >
                <Option
                  v-for="item in citiesArr"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
              <Select
                :disabled="disabledAddr"
                v-model="formLeft.countyId"
                placeholder="请选择区县"
                style="width: 30%"
                @on-change="changeArea"
              >
                <Option
                  v-for="item in countyArr"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
              <!-- <span class="iconfont icon-bianji"></span> -->
            </FormItem>
            <FormItem prop="addr">
              <Input
                v-model="formLeft.addr"
                style="width: 92%"
                :disabled="disabledAddr"
              ></Input>
            </FormItem>
            <FormItem label="联系人：" prop="applicant">
              <Input
                style="width: 92%"
                v-model="formLeft.applicant"
                placeholder="请输入您的姓名，方便客户或平台客服与您联系。"
              ></Input>
              <!-- <span class="iconfont icon-bianji"></span> -->
            </FormItem>
            <FormItem label="联系手机号：">
              <Input
                disabled
                v-model="formLeft.mobile"
                style="width: 70%; margin-right: 2%"
              ></Input>
              <!-- <span class="iconfont icon-bianji" @click="editBtn"></span> -->
              <Button
                type="primary"
                style="width: 20%"
                @click="editBtn('formItem')"
                :loading="editloading"
                v-has="'WSS-3001-1-edit'"
                >修改</Button
              >
              <p style="color: #c2c2c2; font-size: 12px">
                修改后，登录账号会一起修改
              </p>
            </FormItem>
            <FormItem label="店铺注册时间：">
              <p>{{ formLeft.createTime }}</p>
            </FormItem>
            <!-- <FormItem label="邀请码：">
              <Input
                :disabled="disabledCode"
                v-model="formLeft.inviterCode"
                placeholder="请输入邀请码。"
                style="width: 92%"
              ></Input> -->
            <!-- <span class="iconfont icon-bianji"></span> -->
            <!-- </FormItem> -->
            <FormItem
              ><!-- style="text-align: center" -->
              <Button
                :loading="loadings"
                type="primary"
                style="width: 92%"
                @click="keepBTN('formInline')"
                v-has="'WSS-3001-1-edit'"
                >保存</Button
              >
            </FormItem>
          </Form>
        </div>
      </TabPane>
      <TabPane label="主营信息" name="1" v-if="WSS30012">
        <div class="main-b">
          <!-- <div class="spans">
            <span class="icon iconfont icon-zhuying"></span>
            <i>主营信息</i>
          </div> -->
          <div class="ps bianji" style="">
            <!-- 主营车型： -->
            <Row
              type="flex"
              align="bottom"
              :gutter="16"
              style="
                padding-bottom: 20px;
                padding-left: 20px;
                padding-top: 22px;
              "
            >
              <!-- <Col span="3"><p>主营车型：</p></Col> -->
              <Col span="2.5"><span class="spant">主营车型：</span></Col>
              <Col span="20">
                <p>
                  <span v-for="(item,index) in business" :key="index">
                    {{ item }}、
                  </span>
                </p>
                <!--  <Select
                  v-model="formList.carBrands"
                  :disabled="disabled1"
                  filterable
                  multiple
                  :label-in-value="true"
                  @on-change="carBrandChange"
                >
                  <Option
                    v-for="item in carBrandList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select> -->
              </Col>
              <!-- <Col span="2" offset="2">
                <span
                  class="iconfont icon-bianji"
                  @click="editICON(1)"
                  v-has="'WSS-3001-2-edit'"
                ></span>
              </Col>
              <Col v-show="!disabled1" span="2">
                <img
                  @click="saveBTN(1)"
                  src="../../../assets/images/home/icon_保存.svg"
                  alt=""
                  style="width: 24px; height: 24px"
                />
              </Col> -->
            </Row>
            <!-- 主营品牌： -->
            <Row
              type="flex"
              align="bottom"
              :gutter="16"
              style="margin-bottom: 20px; padding-left: 20px"
            >
              <!-- <Col span="3"><p>主营品牌：</p> </Col> -->
              <Col span="2.5"><span class="spant">主营品牌：</span> </Col>
              <Col span="20">
                <p>
                  <span v-for="(item,index) in businessbrand" :key="index">
                    {{ item }}、
                  </span>
                </p>
                <!-- <Select
                  v-model="formList.partBrands"
                  :disabled="disabled2"
                  filterable
                  multiple
                  @on-change="PartBrandsChange"
                  :label-in-value="true"
                >
                  <Option
                    v-for="item in brandList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select> -->
              </Col>
              <!-- <Col span="2" offset="2">
                <span
                  class="iconfont icon-bianji"
                  @click="editICON(2)"
                  v-has="'WSS-3001-2-edit'"
                ></span>
              </Col>
              <Col v-show="!disabled2" span="2">
                <img
                  @click="saveBTN(2)"
                  src="../../../assets/images/home/icon_保存.svg"
                  alt=""
                  style="width: 24px; height: 24px"
                />
              </Col> -->
            </Row>
            <!-- 服务区域： -->
            <Row
              type="flex"
              align="bottom"
              :gutter="16"
              style="margin-bottom: 20px; padding-left: 20px"
            >
              <!-- <Col span="3"><p>主营区域：</p></Col> -->
              <Col span="2.5"><span class="spant">主营区域：</span></Col>
              <Col span="20">
                <p>
                  <span v-for="(item,index) in formList.businessAreas" :key="index">
                    {{ item }}、
                  </span>
                </p>
                <!--< Select
                  v-model="formList.businessAreas"
                  :disabled="disabled3"
                  filterable
                  multiple
                  :label-in-value="true"
                >
                  <Option
                    v-for="item in businessAreaList"
                    :value="item.value"
                    :key="item.value"
                    >{{ item.label }}</Option
                  >
                </Select> -->
              </Col>
              <!-- <Col span="2" offset="2">
                <span
                  class="iconfont icon-bianji"
                  @click="editICON(3)"
                  v-has="'WSS-3001-2-edit'"
                ></span>
              </Col>
              <Col v-show="!disabled3" span="2">
                <img
                  @click="saveBTN(3)"
                  src="../../../assets/images/home/icon_保存.svg"
                  alt=""
                  style="width: 24px; height: 24px"
                />
              </Col> -->
            </Row>
            <!-- 主营配件： -->
            <Row
              type="flex"
              align="bottom"
              :gutter="16"
              style="margin-bottom: 22px; padding-left: 20px"
            >
              <Col span="2.5"><span class="spant">主营配件：</span></Col>
              <!-- <Col span="3"><p>主营配件：</p></Col> -->
              <Col span="20">
                <!-- <p> -->
                <span v-for="(item,index) in list" :key="index">
                  {{ item.name }}、
                </span>
                <!-- </p> -->
                <!-- <Select
                  v-model="formList.partTypes"
                  :disabled="disabled4"
                  filterable
                  multiple
                  :label-in-value="true"
                  @on-change="carBrandChange"
                >
                  <Option
                    v-for="item in carBrandList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select> -->
                <!-- <Cascader
                  v-show="selectShow"
                  :data="data3"
                  trigger="hover"
                  :clearable="false"
                  change-on-select
                  @on-change="handleChange"
                  placeholder="请选择配件分组"
                ></Cascader>
                <Select
                  style="margin-top: 10px"
                  v-model="formList.partTypes"
                  filterable
                  multiple
                  :label-in-value="true"
                  :disabled="disabled4"
                  @on-change="partTypeChange"
                >
                  <Option
                    v-for="item in datalist"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select> -->
              </Col>
              <!-- <Col span="2" offset="2">
                <span
                  class="iconfont icon-bianji"
                  @click="editICON(4)"
                  v-has="'WSS-3001-2-edit'"
                ></span>
              </Col>
              <Col v-show="!disabled4" span="2">
                <img
                  @click="saveBTN(4)"
                  src="../../../assets/images/home/icon_保存.svg"
                  alt=""
                  style="width: 24px; height: 24px; cursor: pointer"
                />
              </Col> -->
            </Row>
          </div>
        </div>
      </TabPane>
      <TabPane label="认证信息" name="2" v-if="WSS30013">
        <div class="main-ku">
          <div>
            <img
              :src="imgs.idCardFrontImg"
              alt=""
              v-show="imgs.idCardFrontImg"
            />
            <div class="div-img" v-show="!imgs.idCardFrontImg">
              <p class="div-p">暂无图片</p>
            </div>
            <div class="picture">
              <span>法人身份证正面</span>
            </div>
          </div>
          <div>
            <img :src="imgs.idCardBackImg" alt="" v-show="imgs.idCardBackImg" />
            <div class="div-img" v-show="!imgs.idCardBackImg">
              <p class="div-p">暂无图片</p>
            </div>
            <div class="picture">
              <span>法人身份证反面</span>
            </div>
          </div>
          <div>
            <img :src="imgs.licenseImg" alt="" v-show="imgs.licenseImg" />
            <div class="div-img" v-show="!imgs.licenseImg">
              <p class="div-p">暂无图片</p>
            </div>
            <div class="picture">
              <span>营业执照</span>
            </div>
          </div>
          <div>
            <img :src="imgs.facadeImg" alt="" v-show="imgs.facadeImg" />
            <div class="div-img" v-show="!imgs.facadeImg">
              <p class="div-p">暂无图片</p>
            </div>
            <div class="picture">
              <span>店铺门面</span>
            </div>
          </div>
        </div>
        <!-- <div class="div-3">
          <Row class="row-img"
            ><Col span="10">
              <div>
                <span>法人身份证正面：</span>
              </div>
              <img
                :src="imgs.idCardFrontImg"
                alt=""
                v-show="imgs.idCardFrontImg"
              />
              <div class="div-img" v-show="!imgs.idCardFrontImg">
                <p class="div-p">暂无图片</p>
              </div></Col
            ><Col span="10">
              <div>
                <span>法人身份证反面：</span>
              </div>
              <img
                :src="imgs.idCardBackImg"
                alt=""
                v-show="imgs.idCardBackImg"
              />
              <div class="div-img" v-show="!imgs.idCardBackImg">
                <p class="div-p">暂无图片</p>
              </div></Col
            ></Row
          >
         
          <Row class="row-img"
            ><Col span="10">
              <div>
                <span
                  >营业执照：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                >
              </div>
              <img :src="imgs.licenseImg" alt="" v-show="imgs.licenseImg" />
              <div class="div-img" v-show="!imgs.licenseImg">
                <p class="div-p">暂无图片</p>
              </div></Col
            ><Col span="10">
              <div>
                <span
                  >店铺门面：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                >
              </div>
              <img :src="imgs.facadeImg" alt="" v-show="imgs.facadeImg" />
              <div class="div-img" v-show="!imgs.facadeImg">
                <p class="div-p">暂无图片</p>
              </div></Col
            ></Row
          >
        </div> -->
      </TabPane>
    </Tabs>
    <!-- 弹框修改手机号 -->
    <Modal
      v-model="modal1"
      title="修改联系手机号"
      footer-hide
      :mask-closable="false"
    >
      <Form
        :model="formItem"
        :label-width="100"
        :rules="ruleValidate"
        ref="formItem"
      >
        <FormItem label="原手机号：" prop="phone">
          <Input v-model="formItem.phone" style="width: 67%" disabled></Input>
          <!-- <p>{{ formItem.phone }}</p> -->
        </FormItem>
        <FormItem prop="phoneCode">
          <Input
            v-model="formItem.phoneCode"
            placeholder="请输入验证码"
            style="width: 67%; margin-right: 2%"
          ></Input
          ><Button type="primary" :disabled="disabled" @click="getCode">{{
            btnText
          }}</Button>
        </FormItem>
        <FormItem label="新手机号：" prop="mobile">
          <Input
            v-model="formItem.mobile"
            placeholder="请输入新联系手机号"
            style="width: 67%"
          ></Input>
        </FormItem>
        <FormItem prop="mobileCode">
          <Input
            v-model="formItem.mobileCode"
            placeholder="请输入验证码"
            style="width: 67%; margin-right: 2%"
          ></Input
          ><Button
            type="primary"
            :disabled="disableds"
            @click="getCodes('formItem')"
            >{{ btnText1 }}</Button
          >
        </FormItem>
        <FormItem style="margin-left: 19%"
          ><Button
            type="primary"
            style="width: 26%"
            @click="btnOK('formItem')"
            :loading="loading"
            >确定</Button
          ></FormItem
        >
      </Form>
    </Modal>
  </div>
</template>

<script>
import {
  getDecoration,
  changeMobile,
  changeDecoration,
  getMainBusinessLines,
  findAll,
  getAllPartBrands,
  getDictionariesItems,
  getlistAllGroup,
  getPartTypeId,
  updateCarBrandForId,
  updatePartBrandForId,
  updatePartTypeForId,
  updateBusinessAreaForId,
  addressList,
  getImg
} from '@/api/myweb/shopmanagement/shopInformation.js'
import { getCodeSMS } from '@/api/user.js'
export default {
  name: 'shopInformation',
  components: {},
  data() {
    return {
      name1: '0',
      WSS30011: false,
      WSS30012: false,
      WSS30013: false,
      list: [],
      arr: [],
      selectShow: false,
      value1: [],
      data3: [],
      disabledCode: false,
      editloading: false, // 修改手机号Loading
      loadings: false, // 保存基础信息Loading
      disabledName: false,
      disabledAddr: false,
      loading: false,
      disabled: false, // 控制按钮是否可以点击（false:可以点击，
      disableds: false,
      totalCount: 0, // 旧手机倒计时
      totalCount1: 0, // 新手机倒计时
      // 新旧手机号
      formItem: {
        platformCode: 'JP-WSS',
        phone: '',
        phoneCode: '',
        phoneDeviceId: '',
        mobile: '',
        mobileCode: '',
        mobileDeviceId: ''
      },
      // 修改手机规则
      ruleValidate: {
        phoneCode: [
          {
            required: true,
            message: '验证码错误',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: false,
            message: '手机号不能为空',
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: '手机号不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
            message: '手机号码格式不正确',
            trigger: 'blur'
          }
        ],
        mobileCode: [
          {
            required: true,
            message: '验证码错误',
            trigger: 'blur'
          }
        ]
      },
      modal1: false,
      // 基础信息
      formLeft: {
        tenantShortName: '',
        addr: '',
        applicant: '',
        mobile: '',
        createTime: '',
        inviterCode: '',
        provinceId: '',
        cityId: '',
        countyId: '',
        changeAddrNum: '',
        changeNameNum: ''
      },
      // 基础信息验证规则
      ruleInline: {
        tenantShortName: [
          {
            required: true,
            message: '店铺名称不能为空',
            trigger: 'blur'
          }
        ],
        cityId: [
          {
            required: true,
            message: '省市区不能为空',
            trigger: 'blur'
          }
        ],
        addr: [
          {
            required: true,
            message: '详细地址不能为空',
            trigger: 'blur'
          }
        ],
        applicant: [
          {
            required: true,
            message: '联系人不能为空',
            trigger: 'blur'
          }
        ]
      },
      // 地址数据
      provinceArr: [],
      citiesArr: [],
      countyArr: [],
      tenantId: JSON.parse(localStorage.getItem('userdetails_leagueInfo'))
        .tenantId, // 租户id
      // 主营信息
      formList: {
        carBrands: '', // 主营车型
        businessAreas: '', // 主营区域
        partBrands: '', // 主营品牌
        partTypes: '' // 主营配件
      },
      disabled1: true,
      disabled2: true,
      disabled3: true,
      disabled4: true,
      carBrandList: [], // 车型
      partTypeList: [], // 配件
      brandList: [], // 品牌
      // 主要区域数据)
      businessAreaList: [
        {
          value: '华北',
          label: '华北'
        },
        {
          value: '华南',
          label: '华南'
        },
        {
          value: '华东',
          label: '华东'
        },
        {
          value: '华中',
          label: '华中'
        },
        {
          value: '西南',
          label: '西南'
        },

        {
          value: '西北',
          label: '西北'
        },
        {
          value: '东北',
          label: '东北'
        },
        {
          value: '国内',
          label: '国内'
        },
        {
          value: '国外',
          label: '国外'
        }
      ],
      carBrandListVOList: [],
      partBrandListVOList: [],
      partTypeListVoList: [],
      // 地址信息
      addressList: [],
      // 认证信息
      imgs: {
        facadeImg: '',
        idCardBackImg: '',
        idCardFrontImg: '',
        licenseImg: ''
      },
      // data2: '',
      datalist: [],
      //主营车型
      business: [],
      //主营品牌
      businessbrand: []
    }
  },
  created() {
    this.getSlider()
    this.getDecoration()
  },
  methods: {
    // 获取权限
    getSlider() {
      let jurisdiction = JSON.parse(localStorage.getItem('siderList'))
      for (let i = 0; i < jurisdiction.length; i++) {
        // console.log(jurisdiction[i])
        if (jurisdiction[i] == 'WSS-3001-1') {
          this.WSS30011 = true
          // this.name1 = '0'
        }
        if (jurisdiction[i] == 'WSS-3001-2') {
          this.WSS30012 = true
          // this.name1 = '1'
        }
        if (jurisdiction[i] == 'WSS-3001-3') {
          this.WSS30013 = true
          // this.name1 = '2'
        }
      }

      console.log(this.WSS30011, this.WSS30012, this.WSS30013)
      if (this.WSS30011 == true) {
        this.name1 = '0'
        this.clickTab(0)
      } else {
        if (this.WSS30012 == true) {
          this.name1 = '1'
          this.clickTab(1)
        } else {
          if (this.WSS30013 == true) {
            this.name1 = '2'
            this.clickTab(2)
          }
        }
      }
      console.log(this.name1)
    },
    async handleChange(value, selectedData) {
      //console.log('1111')
      //console.log(value, selectedData)
      const arr = selectedData[selectedData.length - 1]
      //console.log(arr)
      const res = await getPartTypeId({ partTypeId: arr.id })
      //console.log(res)
      if (res.code == 0) {
        this.datalist = res.data
      }
    },
    // format(labels, selectedData) {
    //   const index = labels.length - 1
    //   const data = selectedData[index] || false
    //   if (data && data.code) {
    //     return labels[index] + ' - ' + data.code
    //   }
    //   return labels[index]
    // },
    // 基础信息
    async getDecoration() {
      const res = await getDecoration()
      console.log(res)
      if (res.status) {
        if (res.data.changeAddrNum == 0) {
          this.disabledAddr = true
        }
        if (res.data.changeNameNum == 0) {
          this.disabledName = true
        }
        if (res.data.inviterCode) {
          this.disabledCode = true
        }
        this.formLeft = res.data
        const rest = await addressList()
        if (rest.status) {
          this.addressList = rest.data
          this.provinceArr = rest.data.province
          this.changeProvinces(this.formLeft.provinceId)
          this.changeCitys(this.formLeft.cityId)
        }
      }
    },
    // 获取验证码(旧手机)
    async getCode() {
      // 按钮60秒倒计时
      this.disabled = true
      this.totalCount = 60
      this.interval = setInterval(() => {
        this.totalCount--
        if (this.totalCount === 0) {
          clearInterval(this.interval)
          this.disabled = false
        }
      }, 1000)
      const res = await getCodeSMS({
        phone: this.formItem.phone,
        platformCode: 'JP-WSS',
        purpose: '2'
      })
      if (res.code == 0) {
        //console.log(res)
        this.formItem.phoneDeviceId = res.data
      }
    },
    // 新手机
    async getCodes(formItem) {
      console.log(this.formItem.mobile)
      if (this.formItem.mobile == undefined) {
      } else {
        this.$refs[formItem].validateField('mobile', async (mobileError) => {
          if (mobileError) {
            console.log(mobileError)
          } else {
            // 按钮60秒倒计时
            this.disableds = true
            this.totalCount1 = 60
            this.interval1 = setInterval(() => {
              this.totalCount1--
              if (this.totalCount1 === 0) {
                clearInterval(this.interval1)
                this.disableds = false
              }
            }, 1000)
            const res = await getCodeSMS({
              phone: this.formItem.mobile,
              platformCode: 'JP-WSS',
              purpose: '2'
            })
            if (res.code == 0) {
              //console.log(res)
              this.formItem.mobileDeviceId = res.data
            }
          }
        })
      }
    },
    // 修改手机号弹窗
    editBtn(formItem) {
      this.editloading = true
      this.formItem = { platformCode: 'JP-WSS' }
      this.$refs[formItem].resetFields()
      this.formItem.phone = this.formLeft.mobile
      this.modal1 = true
      this.editloading = false
    },
    // 关闭
    async btnOK(formItem) {
      this.$refs[formItem].validate(async (valid) => {
        if (valid) {
          this.loading = true
          if (this.formItem.phone === this.formItem.mobile) {
            this.$Message.warning('新旧手机号不能相同')
          } else {
            const res = await changeMobile(this.formItem)
            //console.log(res)
            if (res.status) {
              this.$Message.success('修改成功')
              this.formLeft.mobile = this.formItem.mobile
              this.modal1 = false
            }
          }
          this.loading = false
        }
      })

      //
    },
    // 保存基本信息
    keepBTN(formInline) {
      this.$refs[formInline].validate(async (valid) => {
        if (valid) {
          this.loadings = true
          const res = await changeDecoration(this.formLeft)
          //console.log(res)
          if (res.status) {
            this.getDecoration()
            this.$Message.success('修改成功')
          }
          this.loadings = false
        }
      })
    },
    // 获取主营信息
    async getMainBusinessLines() {
      const res = await getMainBusinessLines()
      // console.log(res)
      if (res.status) {
        this.list = []
        this.list = res.data.partTypeList.map((item) => {
          return {
            id: item.partTypeId, // 传值
            name: item.partTypeName // 传值
          }
        })
      }
      console.log(this.list, 'aa')
      // this.data2 = res.data.partTypes
      this.datalist = this.list
      this.formList = res.data
    },
    // 认证信息
    async getImg() {
      const res = await getImg()
      //console.log(res)
      if (res.status) {
        this.imgs.facadeImg = decodeURIComponent(res.data.facadeImg)
        this.imgs.idCardBackImg = decodeURIComponent(res.data.idCardBackImg)
        this.imgs.idCardFrontImg = decodeURIComponent(res.data.idCardFrontImg)
        this.imgs.licenseImg = decodeURIComponent(res.data.licenseImg)
        //console.log(this.imgs)
      }
    },
    // 切换tab
    clickTab(name) {
      // console.log(name)
      if (name == 1) {
        this.getselect()
        this.getMainBusinessLines()
      } else if (name == 2) {
        this.getImg()
      } else {
        this.getDecoration()
      }
    },
    // 获取车型/品牌/区域/配件
    async getselect() {
      const res = await findAll()
      //console.log(res)
      if (res.code == 0) {
        this.carBrandList = res.data
        this.business = []
        //主营车型
        this.formList.carBrands.map((el) => {
          this.carBrandList.map((elCar) => {
            if (elCar.id == el) {
              this.business.push(elCar.name)
            }
          })
        })
        const rests = await getAllPartBrands()
        if (rests.code == 0) {
          this.brandList = rests.data
          this.businessbrand = []
          //主营品牌
          this.formList.partBrands.map((el) => {
            this.brandList.map((elCar) => {
              if (elCar.id == el) {
                this.businessbrand.push(elCar.name)
              }
            })
          })
          const rest = await getDictionariesItems(['ZYPJFL'])
          if (rest.code == 0) {
            this.partTypeList = rest.data.ZYPJFL
          }
        }
      }
    },
    changeProvinces(value) {
      this.citiesArr = this.addressList[value]
      this.formLeft.provinceId = value
    },
    changeCitys(value) {
      this.countyArr = this.addressList[value]
      this.formLeft.cityId = value
    },
    // 省改变
    changeProvince(value) {
      this.formLeft.cityId = ''
      this.formLeft.countyId = ''
      this.citiesArr = this.addressList[value]
      this.formLeft.provinceId = value
    },
    // 市
    changeCity(value) {
      this.countyArr = this.addressList[value]
      this.formLeft.cityId = value
    },
    // 区
    changeArea(value) {
      this.formLeft.countyId = value
    },
    // 修改主营信息
    async editICON(val) {
      if (val == 1) {
        this.disabled1 = false
      } else if (val === 2) {
        this.disabled2 = false
      } else if (val === 3) {
        this.disabled3 = false
      } else {
        const data = await getlistAllGroup()
        //console.log(data)
        if (data.code == 0) {
          this.data3 = data.data
        }
        this.selectShow = true
        this.disabled4 = false
      }
    },
    carBrandChange(type) {
      this.carBrandListVOList = type.map((item) => {
        return {
          carBrandName: item.label, // 传值
          carBrandId: item.value // 传值
        }
      })
      // console.log('主营车型11',this.carBrandListVOList);
      // console.log(this.carBrandListVOList)
    },
    // 配件品牌改变时
    PartBrandsChange(type) {
      this.partBrandListVOList = type.map((item) => {
        return {
          carBrandName: item.label, // 传值
          carBrandId: item.value // 传值
        }
      })
    },
    // 配件改变
    partTypeChange(type) {
      //console.log(type, '1111111111111')
      this.partTypeListVoList = type.map((item) => {
        return {
          partTypeName: item.label, // 传值
          partTypeId: item.value // 传值
        }
      })
      //console.log(this.partTypeListVoList)
    },
    // 保存主营信息(发请求)
    async saveBTN(val) {
      if (val == 1) {
        const res = await updateCarBrandForId({
          brands: this.carBrandListVOList
        })
        if (res.status) {
          this.disabled1 = true
          this.$Message.success('修改成功')
          this.getMainBusinessLines()
        }
      } else if (val === 2) {
        const res = await updatePartBrandForId({
          brands: this.partBrandListVOList
        })
        if (res.status) {
          this.disabled2 = true
          this.$Message.success('修改成功')
          this.getMainBusinessLines()
        }
      } else if (val === 3) {
        const businessArea = this.formList.businessAreas.join(',')
        const res = await updateBusinessAreaForId({
          businessArea: businessArea
        })
        if (res.status) {
          this.disabled3 = true
          this.$Message.success('修改成功')
          this.getMainBusinessLines()
        }
      } else {
        const res = await updatePartTypeForId({
          partTypes: this.partTypeListVoList
        })
        if (res.status) {
          this.selectShow = false
          this.disabled4 = true
          this.$Message.success('修改成功')
          this.getMainBusinessLines()
        }
      }
    }
  },
  computed: {
    btnText() {
      return this.totalCount !== 0
        ? `${this.totalCount}秒再次获取`
        : '获取验证码'
    },
    btnText1() {
      return this.totalCount1 !== 0
        ? `${this.totalCount1}秒再次获取`
        : '获取验证码'
    }
  },
  watch: {}
}
</script>
<style lang='less' scoped>
//iview级联选择器TabPane修改字体粗细
.shopInformation /deep/.ivu-tabs-nav .ivu-tabs-tab-active {
  color: #2d8cf0;
  font-weight: bold;
}
.shopInformation {
  .icon-bianji {
    font-size: 24px;
    color: #0074ff;
    cursor: pointer;
    margin-left: 2%;
  }

  .main {
    // margin-top: 74px;
    padding-left: 169px;
    width: 747px;
    margin-left: 20%;
    .main-t {
      p {
        color: #c2c2c2;
        font-size: 14px;
        padding-bottom: 10px;
      }
    }

    .ps {
      // padding-top: 20px;
      font-size: 14px;
      color: #555555;
      p {
        padding: 10px 0;
      }
    }
    .ivu-col-span-2 {
      p {
        padding: 0;
      }
    }
    .ivu-col-span-2 {
      img {
        cursor: pointer;
      }
    }
    .bianji {
      .ivu-col-span-2 {
      }
    }
  }
  // 主营信息
  .main-b {
    // margin-top: 80px;
    margin-top: 16px;
    // padding-left: 169px;
    .bianji {
      width: 100%;
      min-width: 1200px;
      min-height: 160px;
      background: #ffffff;
      border: 1px solid #e2e2e2;
      .spant {
        font-weight: bold;
        font-size: 14px;
        line-height: 0px;
        padding-bottom: 20px;
      }
      span {
        margin-left: 0px;
        font-size: 14px;
        line-height: 0px;
        padding-bottom: 20px;
        font-weight: normal;
      }
    }
  }
  // 认证信息
  .div-3 {
    margin-top: 80px;
    padding-left: 169px;
    .row-img {
      margin-top: 45px;
      .ivu-col-span-10 {
        display: flex;
      }
      span {
        // padding-bottom: 23%;
      }
      img {
        vertical-align: text-top;
        width: 250px;
        height: 160px;
        margin-left: 20px;
      }
      .div-img {
        display: inline-block;
        width: 250px;
        height: 160px;
        margin-left: 20px;
        border: 1px dashed #ccc;
        .div-p {
          font-size: 20px;
          text-align: center;
          padding-top: 23%;
        }
      }
    }
  }
}

.main-ku {
  width: 100%;
  min-width: 850px;
  border: 1px solid #e2e2e2;
  min-height: 220px;
  display: flex;
  flex-wrap: wrap;
  padding-left: 12%;
  padding-right: 12%;
  justify-content: space-around;
  padding-top: 16px;
  margin-top: 16px;
  img {
    vertical-align: text-top;
    width: 250px;
    height: 160px;
    margin-left: 20px;
  }
}
.div-img {
  display: inline-block;
  width: 250px;
  height: 160px;
  margin-left: 5%;
  border: 1px dashed #ccc;
  .div-p {
    font-size: 20px;
    text-align: center;
    padding-top: 23%;
  }
}
.picture {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 35px;
}

.shopInformation /deep/.ivu-tabs-bar {
  outline: 0;
  width: 100%;
  padding-top: 20px;
  background: #fff;
  box-shadow: 0px 6px 10px rgba(104, 104, 104, 0.1);
  border-radius: 0px;
  // border: 1px solid;
}
.shopInformation /deep/.ivu-tabs .ivu-tabs-tabpane {
  width: 100%;
  opacity: 1;
  outline: 0;
  min-height: 750px;
  background: #ffffff;
  box-shadow: 0px 6px 10px rgba(104, 104, 104, 0.1);
  opacity: 1;
  // padding-left: 15px;
  // padding-right: 15px;
  padding: 0px 15px;
  border-radius: 0px;
}
.shopInformation /deep/.ivu-tabs {
  box-sizing: border-box;
  position: relative;
  overflow: visible;
  color: #515a6e;
  zoom: 1;
}
</style>